export const extractFormData = <TypeData>(event: React.FormEvent<HTMLFormElement>) => Object.fromEntries(new FormData(event.currentTarget)) as TypeData;
